import SetStoreGroupContainers from '../../containers/setStoreGroup/setStoreGroupContainers';

function SetStoreGroup() {
  return <SetStoreGroupContainers />;
}

export default SetStoreGroup;
